import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const DatePickerField = ({ selectedDate, onChange }) => {
  const [startDate, setStartDate] = useState(selectedDate || null);

  const handleDateChange = (date) => {
    setStartDate(date);
    onChange(date);
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Mono:wght@400;500&display=swap');

        .dpf-wrap {
          display: flex; flex-direction: column; gap: 6px;
          width: 100%; font-family: 'DM Sans', sans-serif;
        }

        .dpf-label-row { display: flex; align-items: center; gap: 4px; }

        .dpf-label { font-size: 12px; font-weight: 600; color: #475569; }

        .dpf-required { color: #EF4444; font-size: 12px; margin-left: 1px; }

        /* Wrapper that holds the input + calendar icon */
        .dpf-input-wrap {
          position: relative; width: 100%;
        }

        .dpf-input-wrap .react-datepicker-wrapper,
        .dpf-input-wrap .react-datepicker__input-container {
          width: 100%;
        }

        /* The actual text input */
        .dpf-input {
          width: 100%;
          padding: 9px 38px 9px 14px;
          font-family: 'DM Sans', sans-serif;
          font-size: 13px; color: #0F172A;
          background: #ffffff;
          border: 1px solid #E2E8F0; border-radius: 10px;
          outline: none;
          box-shadow: 0 1px 2px rgba(0,0,0,0.04);
          transition: border-color 0.15s, box-shadow 0.15s;
          cursor: pointer;
        }
        .dpf-input::placeholder { color: #94A3B8; }
        .dpf-input:focus {
          border-color: #2563EB;
          box-shadow: 0 0 0 3px rgba(37,99,235,0.1);
        }

        /* Calendar icon inside field */
        .dpf-cal-icon {
          position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
          pointer-events: none; color: #94A3B8;
        }

        /* ── Popper / calendar panel ─────────────────────────────── */
        .dpf-wrap .react-datepicker-popper { z-index: 100; }

        .dpf-wrap .react-datepicker {
          font-family: 'DM Sans', sans-serif !important;
          border: 1px solid #E2E8F0 !important;
          border-radius: 12px !important;
          box-shadow: 0 8px 24px rgba(0,0,0,0.1) !important;
          overflow: hidden;
          padding: 4px;
        }

        /* Header */
        .dpf-wrap .react-datepicker__header {
          background: #FAFBFD !important;
          border-bottom: 1px solid #E2E8F0 !important;
          border-radius: 10px 10px 0 0 !important;
          padding: 10px 8px 8px !important;
        }

        .dpf-wrap .react-datepicker__current-month {
          font-family: 'DM Sans', sans-serif !important;
          font-size: 13px !important; font-weight: 700 !important;
          color: #0F172A !important;
        }

        .dpf-wrap .react-datepicker__day-names { margin-top: 6px !important; }

        .dpf-wrap .react-datepicker__day-name {
          font-size: 11px !important; font-weight: 700 !important;
          color: #94A3B8 !important; width: 32px !important; line-height: 32px !important;
        }

        /* Nav arrows */
        .dpf-wrap .react-datepicker__navigation {
          top: 10px !important;
        }
        .dpf-wrap .react-datepicker__navigation-icon::before {
          border-color: #64748B !important;
          border-width: 2px 2px 0 0 !important;
          width: 7px !important; height: 7px !important;
        }
        .dpf-wrap .react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {
          border-color: #2563EB !important;
        }

        /* Day cells */
        .dpf-wrap .react-datepicker__day {
          font-size: 12px !important; font-weight: 500 !important;
          color: #1E293B !important;
          width: 32px !important; line-height: 32px !important;
          border-radius: 8px !important;
          margin: 1px !important;
          transition: background 0.12s, color 0.12s !important;
        }
        .dpf-wrap .react-datepicker__day:hover {
          background: #EFF6FF !important; color: #2563EB !important;
        }
        .dpf-wrap .react-datepicker__day--selected,
        .dpf-wrap .react-datepicker__day--keyboard-selected {
          background: #2563EB !important; color: #ffffff !important;
          font-weight: 700 !important;
        }
        .dpf-wrap .react-datepicker__day--today {
          font-weight: 700 !important; color: #2563EB !important;
        }
        .dpf-wrap .react-datepicker__day--today.react-datepicker__day--selected {
          color: #ffffff !important;
        }
        .dpf-wrap .react-datepicker__day--outside-month {
          color: #CBD5E1 !important;
        }
        .dpf-wrap .react-datepicker__day--disabled {
          color: #E2E8F0 !important; cursor: not-allowed !important;
        }
      `}</style>

      <div className="dpf-wrap">
        <div className="dpf-label-row">
          <label className="dpf-label">Select due date</label>
          <span className="dpf-required">*</span>
        </div>

        <div className="dpf-input-wrap">
          <DatePicker
            selected={startDate}
            onChange={handleDateChange}
            dateFormat="dd/MM/yyyy"
            placeholderText="DD/MM/YYYY"
            customInput={
              <input className="dpf-input" readOnly />
            }
            renderCustomHeader={({ date, decreaseMonth, increaseMonth, prevMonthButtonDisabled, nextMonthButtonDisabled }) => (
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 4px" }}>
                <button
                  onClick={decreaseMonth}
                  disabled={prevMonthButtonDisabled}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: "4px 8px", borderRadius: 6, color: "#64748B", fontSize: 16, lineHeight: 1 }}
                >
                  ‹
                </button>
                <span style={{ fontFamily: "DM Sans, sans-serif", fontSize: 13, fontWeight: 700, color: "#0F172A" }}>
                  {date.toLocaleString("default", { month: "long" })} {date.getFullYear()}
                </span>
                <button
                  onClick={increaseMonth}
                  disabled={nextMonthButtonDisabled}
                  style={{ background: "none", border: "none", cursor: "pointer", padding: "4px 8px", borderRadius: 6, color: "#64748B", fontSize: 16, lineHeight: 1 }}
                >
                  ›
                </button>
              </div>
            )}
          />

          {/* Calendar icon */}
          <span className="dpf-cal-icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path d="M8 2v3M16 2v3M3.5 9.09h17M21 8.5V17c0 3-1.5 5-5 5H8c-3.5 0-5-2-5-5V8.5c0-3 1.5-5 5-5h8c3.5 0 5 2 5 5Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M15.695 13.7h.009M15.695 16.7h.009M11.995 13.7h.009M11.995 16.7h.009M8.294 13.7h.01M8.294 16.7h.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </span>
        </div>
      </div>
    </>
  );
};

export default DatePickerField;